export default "__VITE_ASSET__BqlxyY5Z__"